import { isPlatformBrowser } from '@angular/common';
import { SwiperOptions } from 'swiper/types';
import { Subscription } from 'rxjs';

import {
  AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input,
  OnDestroy, QueryList, Renderer2, ViewChild, ViewChildren, ViewEncapsulation
} from '@angular/core';

import { DeviceService, ImageRatioEnum, SdBannerComponent, SdThemeComponent, SizesEnum } from '@seb/web-design-system/core';
import { SdBlockQuoteComponent } from '@seb/web-design-system/blockquote';
import { SdSliderComponent } from '@seb/web-design-system/sliders';

import type { IVisualQuote } from './visual-quote.interface';

@Component({
  selector: 'sd-visual-quote',
  templateUrl: './visual-quote.component.html',
  styleUrls: ['./visual-quote.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SdSliderComponent, SdBannerComponent, SdBlockQuoteComponent]
})
export class SdVisualQuoteComponent extends SdThemeComponent implements AfterViewInit, OnDestroy {
  @Input()
  isLoading = false;

  @Input()
  context = 'Quote';

  @Input()
  data: IVisualQuote[];

  @Input()
  quoteItemConfig: SwiperOptions = {
    pagination: {
      dynamicBullets: false,
      type: 'bullets',
      clickable: true
    },
    wrapperClass: 'swiper-wrapper c__items',
    breakpoints: {
      0: {
        spaceBetween: 12,
        slidesPerView: 'auto'
      },
      768: {
        spaceBetween: 12
      },
      1280: {
        spaceBetween: 20
      }
    }
  };

  @Input()
  twicPicsAutoSize = true;

  @ViewChildren('myContainer')
  containers: QueryList<ElementRef>;

  @ViewChild('slider', { static: false })
  slider?: SdSliderComponent;

  sizesEnum = SizesEnum;
  imageRatioEnum = ImageRatioEnum;
  subscriptions = new Subscription();
  isDevice$: boolean;

  constructor(
    private renderer: Renderer2,
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.deviceService.isDevice.subscribe((x) => {
        this.isDevice$ = x;
        this.cdRef.markForCheck();
      })
    );

    if (isPlatformBrowser(this.platformId)) {
      this.sliderResizeCallback();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  sliderInitCallback(): void {
    if (this.containers) {
      const bodySelector = this.containers.toArray();
      if (bodySelector) {
        this.setHeight(bodySelector);
      }
    }
  }

  sliderResizeCallback(): void {
    if (this.containers) {
      const bodySelector = this.containers.toArray();
      if (bodySelector) {
        bodySelector.forEach((el) => {
          this.renderer.removeAttribute(el.nativeElement, 'style');
        });
        this.setHeight(bodySelector);
      }
      this.updateMainBackground('--color-primary-base', '.c__body');
    }
  }

  private getMaxHeight(bodySelector: ElementRef[]): number {
    let maxHeight = 0;
    bodySelector.forEach((el) => {
      const thisH = el.nativeElement.clientHeight;
      if (thisH > maxHeight) {
        maxHeight = thisH;
      }
    });
    return maxHeight;
  }

  private setHeight(bodySelector: ElementRef[]): void {
    const maxHeight = this.getMaxHeight(bodySelector);
    bodySelector.forEach((el) => {
      this.renderer.setStyle(el.nativeElement, 'height', maxHeight + 'px');
    });
  }
}
